var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreaterprotection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 797.203 797.203",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M398.593,18.421c-94.506,0-171.12,76.613-171.12,171.12v142.845c0,6.543,0.403,12.991,1.118,19.345h144.705V211.859 h-56.542c-16.436,0-29.759-13.324-29.759-29.759s13.324-29.759,29.759-29.759h160.707c16.436,0,29.758,13.325,29.758,29.759 c0,16.436-13.322,29.759-29.758,29.759h-53.57v139.872h144.707c0.717-6.354,1.117-12.802,1.117-19.345V189.542 C569.713,95.034,493.102,18.421,398.593,18.421z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.869,672.043v-38.741H642.248c0.006,0.282,0.021,0.56,0.021,0.846v37.896L766.869,672.043L766.869,672.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.315,633.302v38.741h124.601v-37.896c0-0.286,0.02-0.562,0.022-0.846L30.315,633.302L30.315,633.302z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255.735,399.346h-6.685c-110.96,0-202.557,82.645-216.759,189.717h129.824c14.429-44.036,49.425-78.721,93.621-92.793 L255.735,399.346L255.735,399.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.135,399.346h-9.678v96.053c45.598,13.438,81.863,48.643,96.615,93.664h129.826 C750.695,481.99,659.098,399.346,548.135,399.346z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.156,361.984c0,60.463-58.01,109.471-129.562,109.471c-71.554,0-129.562-49.008-129.562-109.471 c0,0,66.815,81.355,129.562,81.355C459.34,443.339,528.156,361.984,528.156,361.984z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "766.869,716.283 642.27,716.283 611.947,716.283 611.947,778.782 642.27,778.782 766.869,778.782 797.203,778.782 797.203,716.283 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.916,716.283 30.315,716.283 0,716.283 0,778.782 30.315,778.782 154.916,778.782 185.255,778.782 185.255,716.283 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.594,526.533h-146c-58.968,0-106.773,47.805-106.773,106.77v145.479h141.085v-50.221h-71.413v-77.374h71.413v-62.125 h77.375v62.125h71.412v77.374h-71.412v50.221h141.086V633.302C578.367,574.337,530.562,526.533,471.594,526.533z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterprotection);
export default __webpack_public_path__ + "static/media/greaterprotection.ad3930c3716e7c6a9b8356477f425562.svg";
export { ForwardRef as ReactComponent };